import {Injectable} from '@angular/core';
import {AppHttpClient} from '@common/core/http/app-http-client.service';
import {BackendResponse} from '@common/core/types/backend-response';
import {BiolinkWidget} from './biolink-widget';

@Injectable({
    providedIn: 'root',
})
export class BiolinkWidgetsService {
    static BASE_URI = 'biolink-widgets';
    constructor(private http: AppHttpClient) {}

    create(
        biolinkId: number,
        type: string,
        position: number,
        config: object
    ): BackendResponse<{widget: BiolinkWidget}> {
        return this.http.post(`biolink/${biolinkId}/widget`, {type, position, config});
    }

    update(
        biolinkId: number,
        widgetId: number,
        config: object
    ): BackendResponse<{widget: BiolinkWidget}> {
        return this.http.put(`biolink/${biolinkId}/widget/${widgetId}`, {
            config,
        });
    }

    delete(biolinkId: number, widgetIds: number[]): BackendResponse<void> {
        return this.http.delete(`biolink/${biolinkId}/widget/${widgetIds}`);
    }
}
